<samweb-calling-toast-dialog
   [stateValue]="state.value"
   [leftIconDisabled]="false"
   [rightIconDisabled]="false"
   [samWiggle]="false"
   [leftIcon]="answerIcon"
   [rightIcon]="cancelIcon"
   [progressBar]="false"
   (leftButtonClick)="confirmCall()"
   (rightButtonClick)="cancelCall()"
>
   <div>
      <div class="sam-form-row">
         <div [ngClass]="(outboundCallNotificationTitle$ | async)?.length > 0 ? 'main-text' : 'sub-text'">
            {{ outboundCallNotificationTitle$ | async }}
         </div>
         <div [ngClass]="message.length > 0 ? 'sub-text' : 'main-text'">
            {{ message }}
         </div>
      </div>
   </div>
</samweb-calling-toast-dialog>
